// extracted by mini-css-extract-plugin
module.exports = {"head":"PageHead_head__qj0Cs","title":"PageHead_title__V7AJu","sm":"PageHead_sm__duKax"};